import { useTranslation } from 'react-i18next';

import { FlowSignInHelp } from 'approot/flows/flow-account';
import {
  EVENT_ACTION_OPEN,
  EVENT_CATEGORY_AUTHENTICATION_TLS,
} from 'approot/shared/data-tracker/data-events.constants';
import { pushDataTrackerEvent } from 'approot/shared/data-tracker/data-tracker-push';
import { useRegionData } from 'approot/shared/region/region.apollo';
import { SignInOr } from 'approot/shared/signin/signin-form.style';
import { Box } from 'approot/shared/styles/box.style';
import { PrimaryButton } from 'approot/shared/styles/buttons';
import { SecondaryButtonLink } from 'approot/shared/styles/buttons/secondary-button.style';
import {
  PRIVATE_ACCOUNT_REACTIVATE,
  PRIVATE_JOIN,
  PRIVATE_TRIAL,
} from 'global/private-routes.constants';
import { PUBLIC_JOIN } from 'global/public-routes.constants';
import { NAMESPACE_ACCOUNT_TRANSLATION } from 'internationalise';
import * as Styled from './teaching-learning-sequence-paywall.style';

const TeachingLearningSequencePaywallButtons = ({
  isAccountExpired,
  contentId,
  contentType,
}: {
  isAccountExpired: boolean;
  contentId: number;
  contentType: string;
}) => {
  const { isRegionAU } = useRegionData();
  const { t } = useTranslation(NAMESPACE_ACCOUNT_TRANSLATION);

  const reactivateButton = (
    <PrimaryButton
      data-testid="reactivate-button-tls"
      variant="link"
      to={PRIVATE_ACCOUNT_REACTIVATE}
      onClick={() =>
        pushDataTrackerEvent(
          EVENT_CATEGORY_AUTHENTICATION_TLS,
          EVENT_ACTION_OPEN,
          {
            target_type: 'modal',
            target_identifier: 'reactivate',
            content_id: contentId,
            content_type: contentType,
          }
        )
      }
    >
      Reactivate
    </PrimaryButton>
  );

  const buttonsAU = (
    <PrimaryButton
      data-testid="join-button-tls"
      variant="link"
      to={PUBLIC_JOIN}
      onClick={() =>
        pushDataTrackerEvent(
          EVENT_CATEGORY_AUTHENTICATION_TLS,
          EVENT_ACTION_OPEN,
          {
            target_type: 'modal',
            target_identifier: 'join',
            content_id: contentId,
            content_type: contentType,
          }
        )
      }
    >
      Get Started
    </PrimaryButton>
  );

  const buttonsUS = (
    <>
      <Box $marginBottom={16}>
        <PrimaryButton
          data-testid="join-button-tls"
          variant="link"
          to={PRIVATE_JOIN}
          onClick={() => {
            pushDataTrackerEvent(
              EVENT_CATEGORY_AUTHENTICATION_TLS,
              EVENT_ACTION_OPEN,
              {
                target_type: 'modal',
                target_identifier: 'join',
                content_id: contentId,
                content_type: contentType,
              }
            );
          }}
        >
          Join
        </PrimaryButton>
        <SignInOr $marginBottom={16} $marginTop={16}>
          <span>Or</span>
        </SignInOr>
        <SecondaryButtonLink
          data-testid="trial-button-tls"
          to={PRIVATE_TRIAL}
          onClick={() => {
            pushDataTrackerEvent(
              EVENT_CATEGORY_AUTHENTICATION_TLS,
              EVENT_ACTION_OPEN,
              {
                target_type: 'modal',
                target_identifier: 'trial',
                content_id: contentId,
                content_type: contentType,
              }
            );
          }}
        >
          Try for Free
        </SecondaryButtonLink>
      </Box>
      <Box $justifyContent="center" $marginBottom={0}>
        <Styled.PaywallButtonSmallStyled>
          {t('trialPropositionFirst')}.
        </Styled.PaywallButtonSmallStyled>
      </Box>
      <Box $justifyContent="center" $marginBottom={0}>
        <Styled.PaywallButtonSmallBoldStyled>
          {t('trialPropositionSecond')}.
        </Styled.PaywallButtonSmallBoldStyled>
      </Box>
    </>
  );

  return (
    <Styled.PaywallButtons>
      {isAccountExpired ? reactivateButton : isRegionAU ? buttonsAU : buttonsUS}

      {!isAccountExpired && (
        <FlowSignInHelp
          dataTestId="sign-in-button-tls"
          onClick={() =>
            pushDataTrackerEvent(
              EVENT_CATEGORY_AUTHENTICATION_TLS,
              EVENT_ACTION_OPEN,
              {
                target_type: 'modal',
                target_identifier: 'sign-in',
                content_id: contentId,
                content_type: contentType,
              }
            )
          }
        />
      )}
    </Styled.PaywallButtons>
  );
};

export default TeachingLearningSequencePaywallButtons;
